
import { defineComponent, PropType } from 'vue'
import { Route } from '@/models/Route'
import { parameterizeString } from '@/utils/strings'

export default defineComponent({
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    }
  },
  setup (props) {
    const destination = {
      name: 'Route',
      params: {
        routeId: props.route.id,
        routeName: parameterizeString(props.route.name)
      }
    }

    return {
      destination
    }
  }
})
